import { createAction } from 'redux-actions';
import { message } from 'antd';
import { updateValuation, uploadValuationFile } from '../../../HttpRequests/valuations';
import fetchValuation from './fetchValuation';
import handleException from '../../../Core/Helpers/handleException';
import { loadValuation } from '../State/valuation';
import immutable from 'immutable';
import { setEditable } from '../State/editable';
import prepareValuationItemPercentages from "./prepareValuationItemPercentages";

export const SUBMIT_CERTIFICATE_AMOUNT = 'SUBMIT_CERTIFICATE_AMOUNT';
export const submitCertificateAmount = createAction(SUBMIT_CERTIFICATE_AMOUNT);

export default (amount, files) => async (dispatch, getState) => {
  try {

    //const { valuation } = getState().screens.ValuationView;
    const { id } = getState().screens.ValuationView.valuation;

    // **********************************************
    // save the file

    const formdata = new FormData();
    formdata.append('file', files[0]);
    formdata.append('name', files[0].name);

    await uploadValuationFile({ id, data: formdata, config: {

      onUploadProgress: (progress) => {
        /* const uploaded =  */Math.floor((progress.loaded * 100) / progress.total);
      }

    }});

    let valuation = immutable.fromJS(getState().screens.ValuationView.valuation);
    valuation = valuation.set('payment_certificate_storage_path', files[0].name);

    valuation = valuation.toJS();

    // **********************************************
    // now set the amount
    const data = {
      certificate_amount: amount
    };
    const response = await updateValuation({ id, data });

    //const valuation = response.data.data;

    dispatch(setEditable(false));

    message.success("Valuation Updated");

    dispatch(fetchValuation());
    dispatch(loadValuation(valuation));
    dispatch(prepareValuationItemPercentages());

  } catch (error) {

    handleException(error);

    throw error;

  }
};
